<!--<div id="" class="uk-width-1-1" uk-sticky>-->
<div id="" class="uk-width-1-1">
  <!--Desktop Menu-->
  <div id="main-menu" class="uk-visible@m">

    <div class="uk-navnar uk-navbar-container uk-sticky uk-sticky-fixed" uk-sticky>
      <div class="uk-container uk-container-expand">

        <nav class="uk-navbar fixed-navbar">

          <div class="uk-navbar-left">
            <a class="logo" [routerLink]="['home']">
              <img src="../../../../assets/logo/svg/EOSC%20OPEN%20SCIENCE%20OBSERVATORY%20LOGO.svg" width="180px">
            </a>
          </div>

          <div class="uk-navbar-center">
            <ul class="uk-navbar-nav user_actions">
              <!--              <li [routerLinkActive]="'uk-active'">-->
              <!--                <a class="uk-icon uk-animation-fade" [routerLink]="['/home']" aria-expanded="false">-->
              <!--                  <span class="uk-text-small uk-margin-small-right">Home</span>-->
              <!--                </a>-->
              <!--              </li>-->
              <li [routerLinkActive]="'uk-active'">
                <a class="uk-icon uk-animation-fade" aria-expanded="false">
                  <span class="uk-text-small uk-margin-small-right">About</span>
                </a>
                <!--                <div id="about-dropbar" class="uk-dropbar uk-dropbar-top" uk-dropdown="stretch: x; mode: click; top: 81px; offset: 1">-->
                <div id="about-dropbar" class="uk-dropdown" uk-dropdown="mode: click; pos: bottom-center"
                  style="width: 50vw">
                  <!--                  <div class="uk-grid-divider" uk-grid>-->
                  <!--                    <div class="uk-width-1-4">-->
                  <!--                      <h3>About</h3>-->
                  <!--                    </div>-->
                  <!--                    <div class="uk-width-3-4">-->
                  <!--                      <div class="uk-child-width-1-2" uk-grid>-->
                  <!--                        <a class="uk-link-reset" (click)="navigate('/about/eosc-observatory', 'about-dropbar')">-->
                  <!--                          <h6 class="uk-text-primary">About EOSC Observatory</h6>-->
                  <!--                          <div>Explore the EOSC Open Science Observatory, a platform for monitoring Open Science and EOSC progress across Europe.</div>-->
                  <!--                        </a>-->
                  <!--                        <a class="uk-link-reset" (click)="navigate('/about/eosc-track', 'about-dropbar')">-->
                  <!--                          <h6 class="uk-text-primary">About EOSC Track</h6>-->
                  <!--                          <div>Learn about EOSC Track, a project enhancing the EOSC Open Science Observatory to support Open Science monitoring.</div>-->
                  <!--                        </a>-->
                  <!--                        <a class="uk-link-reset" (click)="navigate('/about/news', 'about-dropbar')">-->
                  <!--                          <h6 class="uk-text-primary">News</h6>-->
                  <!--                          <div>Get the latest updates on the EOSC Open Science Observatory and EOSC Track project.</div>-->
                  <!--                        </a>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div class="uk-padding-xsmall">
                    <div class="uk-drop-grid uk-child-width-1-3 uk-grid-match" uk-grid>
                      <a class="uk-link-reset" (click)="navigate('/about/eosc-observatory', 'about-dropbar')">
                        <div class="uk-tile uk-tile-hover uk-padding-xsmall">
                          <h6 class="uk-text-primary">About EOSC Observatory</h6>
                          <div>Explore the EOSC Open Science Observatory, a platform for monitoring Open Science and
                            EOSC progress across Europe.</div>
                        </div>
                      </a>
                      <a class="uk-link-reset" (click)="navigate('/about/eosc-track', 'about-dropbar')">
                        <div class="uk-tile uk-tile-hover uk-padding-xsmall">
                          <h6 class="uk-text-primary">About EOSC Track</h6>
                          <div>Learn about EOSC Track, a project enhancing the EOSC Open Science Observatory to support
                            Open Science monitoring.</div>
                        </div>
                      </a>
                      <a class="uk-link-reset" (click)="navigate('/about/news', 'about-dropbar')">
                        <div class="uk-tile uk-tile-hover uk-padding-xsmall">
                          <h6 class="uk-text-primary">News</h6>
                          <div>Get the latest updates on the EOSC Open Science Observatory and EOSC Track project.</div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li [routerLinkActive]="'uk-active'">
                <a class="uk-icon uk-animation-fade" [routerLink]="['/explore']" aria-expanded="false">
                  <span class="uk-text-small uk-margin-small-right">Explore</span>
                </a>
              </li>
              <!--              Show contact -->
              <li [routerLinkActive]="'uk-active'">
                <a class="uk-icon uk-animation-fade" aria-expanded="false">
                  <span class="uk-text-small uk-margin-small-right">Resources</span>
                </a>
                <div id="resources-dropbar" class="uk-dropdown" uk-dropdown="mode: click; pos: bottom-center" style="width: 60vw">
                  <!--                  <div id="about-dropbar" class="uk-dropbar uk-dropbar-top" uk-drop="stretch: x; mode: click">-->
                  <div class="uk-padding-xsmall">
                    <div class="uk-drop-grid uk-child-width-1-4 uk-grid-match" uk-grid>
                      <a class="uk-link-reset"
                        (click)="navigate('/resources/data-workflow-and-methodology', 'resources-dropbar')">
                        <div class="uk-tile uk-tile-hover uk-padding-xsmall">
                          <h6 class="uk-text-primary">Data Workflow & Methodology</h6>
                          <div>Learn about the EOSC Open Science Observatory data workflow and the methodology used for
                            monitoring Open Science and EOSC progress.</div>
                        </div>
                      </a>
                      <a class="uk-link-reset"
                        (click)="navigate('/resources/publications-and-deliverables', 'resources-dropbar')">
                        <div class="uk-tile uk-tile-hover uk-padding-xsmall">
                          <h6 class="uk-text-primary">Publications & Deliverables</h6>
                          <div>Access key publications related to the EOSC Open Science Observatory and on Open Science
                            monitoring.</div>
                        </div>
                      </a>
                      <a class="uk-link-reset" (click)="navigate('/resources/data-download', 'resources-dropbar')">
                        <div class="uk-tile uk-tile-hover uk-padding-xsmall">
                          <h6 class="uk-text-primary">Data Download</h6>
                          <div>Get the latest updates and download data from the EOSC Open Science Observatory.</div>
                        </div>
                      </a>
                      <a class="uk-link-reset" (click)="navigate('/resources/support-and-faq', 'resources-dropbar')">
                        <div class="uk-tile uk-tile-hover uk-padding-xsmall">
                          <h6 class="uk-text-primary">Support & FAQ</h6>
                          <div>Find support and guidance for using the EOSC Open Science Observatory platform.</div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li [routerLinkActive]="'uk-active'">
                <a class="uk-icon uk-animation-fade" [routerLink]="['/contact']" aria-expanded="false">
                  <span class="uk-text-small uk-margin-small-right">Contact</span>
                </a>
              </li>
            </ul>
          </div>

          <div class="uk-navbar-right">
            <ul class="uk-navbar-nav user_actions">
              <li>
                <a *ngIf="userInfo" class="uk-icon" aria-expanded="false">
                  <div class="uk-flex">
                    <div class="uk-padding-remove uk-flex uk-flex-middle">
                      <!--                      <span class="uk-text-small uk-text-bold uk-width-1-1">{{userInfo.user.fullname}}</span>-->
                      <span *ngIf="currentCoordinator || currentStakeholder || currentAdministrator" class="">
                        {{(currentStakeholder?.name ? currentStakeholder.name : (currentCoordinator?.name ?
                        currentCoordinator.name : currentAdministrator.name))}}
                      </span>
                    </div>
                    <div *ngIf="!userInfo.user.profile?.picture; else elseBlock">
                      <svg height="60" width="60">
                        <circle cx="30" cy="30" r="20" stroke-width="1"></circle>
                        <text dy=".4em" font-size="16" text-anchor="middle" x="50%" y="50%">{{parseUsername()}}</text>
                        <circle class="notification" *ngIf="unreadMessages.totalUnread > 0" cx="45" cy="15" r="7"
                          stroke-width="1"></circle>
                        <text class="notification" *ngIf="unreadMessages.totalUnread > 0" x="45" y="19"
                          text-anchor="middle">
                          {{unreadMessages?.totalUnread.toString()}}
                        </text>
                      </svg>
                    </div>
                    <ng-template #elseBlock>
                      <svg height="60" width="60">
                        <image x="10" y="10" [attr.href]="'data:image;base64,' + userInfo.user.profile.picture"
                          height="40" width="40" clip-path="inset(0% round 20px)" />
                        <!--                        For messages-->
                        <circle class="notification" *ngIf="unreadMessages?.totalUnread > 0" cx="45" cy="15" r="7"
                          stroke-width="1"></circle>
                        <text class="notification" *ngIf="unreadMessages?.totalUnread > 0" x="45" y="19"
                          text-anchor="middle">
                          {{unreadMessages?.totalUnread.toString()}}
                        </text>
                      </svg>
                    </ng-template>
                  </div>
                </a>
                <div *ngIf="userInfo" class="uk-padding-remove-horizontal uk-dropdown"
                  uk-dropdown="mode: click; offset: -2; delay-hide: 0; flip: false; pos: bottom-right">
                  <ul class="uk-nav uk-dropdown-nav">
                    <li class="user-info">
                      <div>
                        <div class="uk-text-bold">{{userInfo.user.fullname}}</div>
                        <div class="uk-text-meta">{{userInfo.user.email}}</div>
                      </div>
                    </li>
                    <hr *ngIf="userInfo.stakeholders?.length > 0">
                    <li class="groups" *ngFor="let stakeholder of userInfo.stakeholders">
                      <a (click)="setGroup(stakeholder)"><span class="material-icons uk-margin-right">group</span>
                        {{stakeholder.name + (stakeholder.type === 'association' ? (', EOSC Association '+
                        (stakeholder.country ? '(' + stakeholder.country + ')': '')) : '') }}
                        <!--                        for messages-->
                        <svg *ngIf="showUnread(stakeholder.id)" height="20" width="20">
                          <circle class="notification" cx="7.5" cy="10" r="7" stroke-width="1"></circle>
                          <text class="notification" x="7.2" y="13" text-anchor="middle">
                            {{showUnread(stakeholder.id)}}
                          </text>
                        </svg>
                      </a>
                    </li>
                    <hr *ngIf="userInfo.coordinators?.length > 0">
                    <li class="groups" *ngFor="let coordinator of userInfo.coordinators">
                      <a (click)="setCoordinator(coordinator)">
                        <span class="material-icons uk-margin-right">group</span>{{coordinator.name}}
                        <!--                        For messages-->
                        <svg *ngIf="showUnread(coordinator.id)" height="20" width="20">
                          <circle class="notification" cx="7.5" cy="10" r="7" stroke-width="1"></circle>
                          <text class="notification" x="7.2" y="13" text-anchor="middle">
                            {{showUnread(coordinator.id)}}
                          </text>
                        </svg>
                      </a>
                    </li>
                    <ng-container *ngIf="userInfo.administrators?.length > 0">
                      <hr>
                      <li *ngFor="let admin of userInfo.administrators">
                        <a (click)="setAdministrator(admin)">
                          <span class="material-icons uk-margin-right">shield</span>{{admin.name}}
                          <!--                        For messages-->
                          <svg *ngIf="showUnread(admin.id)" height="20" width="20">
                            <circle class="notification" cx="7.5" cy="10" r="7" stroke-width="1"></circle>
                            <text class="notification" x="7.2" y="13" text-anchor="middle">
                              {{showUnread(admin.id)}}
                            </text>
                          </svg>
                        </a>
                      </li>
                    </ng-container>
                    <hr *ngIf="showArchive">
                    <li *ngIf="showArchive" class="groups">
                      <a class="" style="cursor: default; pointer-events: none">
                        <span class="material-icons uk-margin-right">space_dashboard</span>
                        <span class="uk-text-uppercase uk-text-bold">Other dashboards</span>
                      </a>
                    </li>
                    <li *ngIf="showArchive" class="uk-margin-small-left">
                      <a class="" [routerLink]="['/country-pages']" aria-expanded="false">
                        <span class="uk-text-small uk-margin-medium-left">Country pages</span>
                      </a>
                    </li>
                    <li *ngIf="showArchive" class="uk-margin-small-left">
                      <a class="" [routerLink]="['/country_selector']" aria-expanded="false">
                        <span class="uk-text-small uk-margin-medium-left">National Contributions by country</span>
                      </a>
                    </li>
                    <li *ngIf="showArchive" class="uk-margin-small-left">
                      <a class="" [routerLink]="['/archive']" aria-expanded="false">
                        <span class="uk-text-small uk-margin-medium-left">Archive 2021</span>
                      </a>
                    </li>
                    <hr>
                    <li>
                      <a class="" [routerLink]="['/profile']">
                        <span class="material-icons uk-margin-right">account_circle</span>My Profile
                      </a>
                    </li>
                    <hr>
                    <li>
                      <a id="logout" (click)="logout()"><span class="material-icons uk-margin-right">logout</span>Log
                        out</a>
                    </li>
                  </ul>
                </div>
              </li>
              <li *ngIf="!userInfo" class="uk-animation-fade">
                <a class="uk-button uk-button-link" (click)="logInButton()">Login</a>
              </li>
            </ul>
          </div>

        </nav>

      </div>

    </div>

  </div>
  <!-- Mobile Menu -->
  <div id="main-menu-small" class="tm-header uk-hidden@m tm-header-transparent">
    <nav class="uk-navbar uk-navbar-container" uk-navbar>
      <div class="uk-navbar-left">
        <!-- Hamburger button -->
        <a class="uk-navbar-toggle" uk-toggle="target: #tm-mobile" href="#">
          <span uk-navbar-toggle-icon></span>
        </a>
      </div>

      <div class="uk-navbar-center">
        <a class="logo" [routerLink]="['home']">
          <img src="../../../../assets/logo/svg/EOSC%20OPEN%20SCIENCE%20OBSERVATORY%20LOGO.svg" width="100px">
        </a>
      </div>

      <div class="uk-navbar-right">
        <div>
          <ul class="uk-navbar-nav">
            <li *ngIf="!userInfo">
              <a class="" aria-label="Login" (click)="logInButton()">
                <span class="material-symbols-outlined">person</span>
              </a>
            </li>
            <li *ngIf="userInfo">
              <a *ngIf="userInfo" class="uk-icon" aria-expanded="false" href=" #offcanvas-account" uk-toggle>
                <div class="uk-flex">
<!--                  fixme selected stakeholder not show for now on the mobile menu-->
<!--                  <div class="uk-padding-remove uk-flex uk-flex-middle">-->
<!--                    &lt;!&ndash;                      <span class="uk-text-small uk-text-bold uk-width-1-1">{{userInfo.user.fullname}}</span>&ndash;&gt;-->
<!--                    <span *ngIf="currentCoordinator || currentStakeholder || currentAdministrator" class="">-->
<!--                        {{(currentStakeholder?.name ? currentStakeholder.name : (currentCoordinator?.name ?-->
<!--                      currentCoordinator.name : currentAdministrator.name))}}-->
<!--                      </span>-->
<!--                  </div>-->
                  <div *ngIf="!userInfo.user.profile?.picture; else elseBlock">
                    <svg height="60" width="60">
                      <circle cx="30" cy="30" r="20" stroke-width="1"></circle>
                      <text dy=".4em" font-size="16" text-anchor="middle" x="50%" y="50%">{{parseUsername()}}</text>
                      <circle class="notification" *ngIf="unreadMessages.totalUnread > 0" cx="45" cy="15" r="7"
                              stroke-width="1"></circle>
                      <text class="notification" *ngIf="unreadMessages.totalUnread > 0" x="45" y="19"
                            text-anchor="middle">
                        {{unreadMessages?.totalUnread.toString()}}
                      </text>
                    </svg>
                  </div>
                  <ng-template #elseBlock>
                    <svg height="60" width="60">
                      <image x="10" y="10" [attr.href]="'data:image;base64,' + userInfo.user.profile.picture"
                             height="40" width="40" clip-path="inset(0% round 20px)" />
                      <!--                        For messages-->
                      <circle class="notification" *ngIf="unreadMessages?.totalUnread > 0" cx="45" cy="15" r="7"
                              stroke-width="1"></circle>
                      <text class="notification" *ngIf="unreadMessages?.totalUnread > 0" x="45" y="19"
                            text-anchor="middle">
                        {{unreadMessages?.totalUnread.toString()}}
                      </text>
                    </svg>
                  </ng-template>
                </div>
              </a>
<!--              <a class="" aria-label="Login" href=" #offcanvas-account" uk-mobile-toggle>-->
<!--                <span class="material-symbols-outlined">person</span>-->
<!--              </a>-->
              <!-- Offcanvas for user login -->
              <div id="offcanvas-account" uk-offcanvas="overlay: true; flip: true">
                <div class="uk-offcanvas-bar uk-width-expand">

                  <button class="uk-offcanvas-close" type="button" uk-close></button>

                  <div *ngIf="userInfo">
                    <h4 class="uk-text-bold uk-margin-small-bottom">{{ userInfo.user.fullname }}</h4>
                    <div class="uk-text-meta uk-margin-small-bottom">{{ userInfo.user.email }}</div>
                    <hr>

                    <!--Stakeholders-->
                    <div *ngIf="userInfo.stakeholders?.length > 0">
                      <h5 class="uk-text-uppercase uk-text-bold">Stakeholders</h5>
                      <ul class="uk-nav uk-nav-default">
                        <li *ngFor="let stakeholder of userInfo.stakeholders">
                          <a (click)="setGroup(stakeholder)">
                            {{ stakeholder.name }}
                            <svg *ngIf="showUnread(stakeholder.id)" height="20" width="20" style="margin-left: 8px;">
                              <circle cx="10" cy="10" r="7" stroke-width="1" fill="#E53935" stroke="E53935"></circle>
                              <text x="10" y="14" text-anchor="middle" font-size="10px" fill="#FFFFFF">
                                {{ showUnread(stakeholder.id) }}
                              </text>
                            </svg>
                          </a>
                        </li>
                      </ul>
                      <hr>
                    </div>
                    <!--Coordinators-->
                    <div *ngIf="userInfo.coordinators?.length > 0">
                      <h5 class="uk-text-uppercase uk-text-bold">Coordinators</h5>
                      <ul class="uk-nav uk-nav-default">
                        <li *ngFor="let coordinator of userInfo.coordinators">
                          <a (click)="setCoordinator(coordinator)">
                            {{ coordinator.name }}
                            <svg *ngIf="showUnread(coordinator.id)" height="20" width="20" style="margin-left: 8px;">
                              <circle class="notification" cx="7.5" cy="10" r="7" stroke-width="1">
                                <text class="notification" x="7.2" y="13" text-anchor="middle">
                                  {{ showUnread(coordinator.id) }}
                                </text>
                              </circle>
                            </svg>
                          </a>
                        </li>
                      </ul>
                      <hr>
                    </div>
                    <!--Administrators-->
                    <div *ngIf="userInfo.administrators?.length > 0">
                      <h5 class="uk-text-uppercase uk-text-bold">Administrators</h5>
                      <ul class="uk-nav uk-nav-default">
                        <li *ngFor="let admin of userInfo.administrators">
                          <a (click)="setAdministrator(admin)">
                            {{ admin.name }}
                            <svg *ngIf="showUnread(admin.id)" height="20" width="20" style="margin-left: 8px;">
                              <circle class="notification" cx="7.5" cy="10" r="7" stroke-width="1"></circle>
                              <text class="notification" x="7.2" y="13" text-anchor="middle">
                                {{ showUnread(admin.id) }}
                              </text>
                            </svg>
                          </a>
                        </li>
                      </ul>
                      <hr>
                    </div>
                    <!--Archive Links-->
                    <div *ngIf="showArchive">
                      <h5 class="uk-text-uppercase uk-text-bold">Other Dashboards</h5>
                      <ul class="uk-nav uk-nav-default">
                        <li>
                          <a [routerLink]="['/country_selector']" (click)="closeOffCanvas('offcanvas-account')">
                            National Contributions by country
                          </a>
                        </li>
                        <li>
                          <a [routerLink]="['/archive']" (click)="closeOffCanvas('offcanvas-account')">
                            Archive 2021
                          </a>
                        </li>
                      </ul>
                      <hr>
                    </div>
                    <!-- My Profile-->
                    <ul class="uk-nav uk-nav-default">
                      <li>
                        <a [routerLink]="['/profile']" (click)="closeOffCanvas('offcanvas-account')">
                          <span class="material-icons uk-margin-right">account_circle</span>My Profile
                        </a>
                      </li>
                      <li>
                        <a id="logout" (click)="logout()">
                          <span class="material-icons uk-margin-right">logout</span>Log out
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div *ngIf="!userInfo">
                    <button class="uk-button uk-button-primary uk-width-1-1" (click)="logInButton()">Login</button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>

<!--    <button class="uk-button uk-button-default" type="button" uk-mobile-toggle="target: #offcanvas-nav">Default Nav</button>-->


<!--    <div id="offcanvas-nav" uk-offcanvas="overlay: true">-->
<!--      <div class="uk-offcanvas-bar uk-width-expand">-->
<!--        <button class="uk-offcanvas-close" type="button" uk-close></button>-->

<!--      <nav uk-dropnav="mode: click">-->
<!--       <ul class="uk-subnav">-->
<!--        <li>-->
<!--              <a href>About <span uk-drop-parent-icon></span></a>-->
<!--              <div class="uk-dropdown">-->
<!--                  <ul class="uk-nav uk-dropdown-nav">-->
<!--                      <li><a [routerLink]="['/about/eosc-observatory']" (click)="closeOffCanvas()">About EOSC Observatory</a></li>-->
<!--                      <li><a [routerLink]="['/about/eosc-track']" (click)="closeOffCanvas()">About EOSC Track</a></li>-->
<!--                      <li><a [routerLink]="['/about/news']" (click)="closeOffCanvas()">News</a></li>-->
<!--                  </ul>-->
<!--              </div>-->
<!--        </li>-->
<!--        <li><a [routerLink]="['/explore']" (click)="closeOffCanvas()">Explore</a></li>-->
<!--        </ul>-->
<!--      </nav>-->
<!--      </div>-->
<!--    </div>-->

    <!-- Offcanvas Menu -->
    <div id="tm-mobile" class="uk-offcanvas uk-offcanvas-overlay" uk-offcanvas="mode: none; overlay: true">
      <div class="uk-offcanvas-bar uk-padding-remove uk-offcanvas-none" style="width: 100%;">

        <!-- Offcanvas navbar -->
        <nav class="uk-navbar-container uk-background-default uk-sticky uk-sticky-fixed" uk-navbar>

          <div class="uk-navbar-left">
            <button class="uk-navbar-toggle uk-icon uk-close" (click)="closeOffCanvas('tm-mobile')">
              <span class="uk-display-inline-block">
                <span class="material-icons" style="font-size: 30px;">close</span>
              </span>
            </button>
          </div>

          <div class="uk-navbar-center">
            <a class="logo" [routerLink]="['home']">
<!--              <a class="uk-logo uk-navbar-item uk-flex uk-flex-middle small" [routerLink]="['home']">-->
              <img src="../../../../assets/logo/svg/EOSC%20OPEN%20SCIENCE%20OBSERVATORY%20LOGO.svg" width="100px">
            </a>
          </div>

<!--          <div class="uk-navbar-right"></div>-->
        </nav>

        <div class="uk-sticky-placeholder" style="height: 65px; width: 390px; margin: 0px;"></div>

        <!-- Menu items -->
<!--        <ul class="uk-nav uk-nav-default uk-nav-parent-icon" uk-nav>-->
          <ul class="uk-nav uk-nav-primary uk-list uk-list-large" uk-nav>
          <li class="uk-parent" [routerLinkActive]="'uk-active'">
            <a href="#">About<span class="uk-nav-parent-icon"></span></a>
            <ul class="uk-nav-sub">
              <li><a [routerLink]="['/about/eosc-observatory']" (click)="closeOffCanvas('tm-mobile')">About EOSC Observatory</a></li>
              <li><a [routerLink]="['/about/eosc-track']" (click)="closeOffCanvas('tm-mobile')">About EOSC Track</a></li>
              <li><a [routerLink]="['/about/news']" (click)="closeOffCanvas('tm-mobile')">News</a></li>
            </ul>
          </li>

          <li [routerLinkActive]="'uk-active'"><a [routerLink]="['/explore']" (click)="closeOffCanvas('tm-mobile')">Explore</a></li>
          <li class="uk-parent" [routerLinkActive]="'uk-active'">
            <a href="#">Resources<span class="uk-nav-parent-icon"></span></a>
            <ul class="uk-nav-sub">
              <li><a [routerLink]="['/resources/data-workflow-and-methodology']" (click)="closeOffCanvas('tm-mobile')">Data Workflow & Methodology</a></li>
              <li><a [routerLink]="['/resources/publications-and-deliverables']" (click)="closeOffCanvas('tm-mobile')">Publications & Deliverables</a></li>
              <li><a [routerLink]="['/resources/data-download']" (click)="closeOffCanvas('tm-mobile')">Data Download</a></li>
              <li><a [routerLink]="['/resources/support-and-faq']" (click)="closeOffCanvas('tm-mobile')">Support & FAQ</a></li>
            </ul>
          </li>
          <li [routerLinkActive]="'uk-active'"><a [routerLink]="['/contact']" (click)="closeOffCanvas('tm-mobile')">Contact</a></li>
        </ul>

      </div>
    </div>
  </div>
</div>

  <!-- Consent modal -->
<div id="consent-modal" uk-modal="esc-close: false; bg-close: false ">
  <div class="uk-modal-dialog uk-modal-body">
    <!--    <h2 class="uk-modal-title">Headline</h2>-->
    <p>Click the link below and read it carefully. By pressing I agree you acknowledge that you have read and agree to
      the following terms.</p>
    <hr>
    <a *ngIf="acceptedPrivacyPolicy" target="_blank"
      href="../../../../assets/pdf/{{acceptedPrivacyPolicy.privacyPolicy.filename}}">EOSC Observatory Privacy
      Policy</a>
    <p class="uk-text-right">
      <button class="uk-button uk-button-secondary" type="button" (click)="closeModal()">Close</button>
      <button class="uk-button uk-button-primary" type="button" (click)="updateConsent()">I agree</button>
    </p>
  </div>
</div>
